import React from 'react';
import NewsCard from './NewsCard';
import SubsctibeCard from './SubscribeCard';
import { data } from './mockData';
import './styles.scss';

const NewsCards = ({ posts = [], subscribeTitle, subscribeDescription, subscribePolicy }) => (
    // <div className="news-cards">
    //     {data.map((item, index) => (
    //         <React.Fragment key={item.title}>
    //             <NewsCard data={item} />
    //             {index === 5 && <SubsctibeCard />}
    //         </React.Fragment>
    //     ))}
    // </div>
    <div className="news-cards">
        {posts.map(item => (
            <NewsCard key={item.title} data={item} />
        ))}
        <SubsctibeCard title={subscribeTitle} description={subscribeDescription} policy={subscribePolicy} />
    </div>
);

export default NewsCards;
